export const DEFAULT_PROGRESS_BAR_TEXT =
  "You've viewed {{number}} of {{number}} items";

const PROGRESS_BAR_CLASSES_PREFIX = "ProgressBar";

export const PROGRESS_BAR_CLASSES = {
  bar: `${PROGRESS_BAR_CLASSES_PREFIX}-bar`,
  indicator: `${PROGRESS_BAR_CLASSES_PREFIX}-indicator`,
  centered: `${PROGRESS_BAR_CLASSES_PREFIX}-centered`,
};
